import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useLang } from "@/context/LanguageContext";

const FAQ_KEYS = [1, 2, 3, 4, 5, 6, 7, 8];

export default function FAQSection() {
  const { t } = useLang();

  return (
    <section data-testid="faq-section" className="max-w-4xl mx-auto px-6 md:px-10 py-14">
      <div className="text-center mb-8">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-brand">{t("faq.badge")}</div>
        <h2 className="mt-2 font-display font-bold text-3xl sm:text-4xl tracking-tight text-zinc-900">
          {t("faq.title")}
        </h2>
        <p className="mt-3 text-base text-zinc-600 max-w-xl mx-auto leading-relaxed">
          {t("faq.subtitle")}
        </p>
      </div>

      <div className="bg-white rounded-3xl border border-zinc-100 px-6 md:px-8">
        <Accordion type="single" collapsible className="w-full">
          {FAQ_KEYS.map((n) => (
            <AccordionItem key={n} value={`faq-${n}`} data-testid={`faq-item-${n}`} className="border-zinc-100">
              <AccordionTrigger data-testid={`faq-trigger-${n}`} className="font-display font-semibold text-zinc-900 text-base hover:no-underline">
                {t(`faq.q${n}`)}
              </AccordionTrigger>
              <AccordionContent data-testid={`faq-content-${n}`} className="text-zinc-600 leading-relaxed">
                {t(`faq.a${n}`)}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
